import { certifications, levels, list, note } from '../constants';

const answerMap: { [key: number]: JSX.Element } = {
  0: (
    <div className='answer-txt'>
      After successfully completing the task, simply inform Marvin.
    </div>
  ),
  1: (
    <>
      <div className='answer-txt'>
        The amount of b-coins for a successful candidate recommendation varies
        depending on the position level:
      </div>
      <ul className='answer-txt-list'>
        {levels.map((level, index) => (
          <li key={index}>
            {level.title} - <b>{level.cost}</b>
          </li>
        ))}
      </ul>
      <div className='answer-txt'>
        b-coin is accrued after the candidate has worked for <b>1 month</b> in
        the company.
      </div>
    </>
  ),

  2: (
    <>
      <div className='answer-txt'>
        The total limit per month is: 3 tags for stories and 2 tags for posts.
      </div>
      <div className='answer-txt'>
        The total limit of reposts per month is: 5
      </div>
    </>
  ),
  3: (
    <>
      <div className='answer-txt'>
        You can complete this task up to 2 times for an internal audience and 2
        times for an external audience.
      </div>
      <div className='answer-txt'>
        <b>
          Are there any restrictions on the number of sessions for each
          audience?
        </b>
      </div>
      <div className='answer-txt'>
        Yes, you can conduct up to 2 unique sessions for each audience type
        (internal and external) to qualify for internal currency rewards.
      </div>
      <div className='answer-txt'>
        <b>Can I repeat the same webinar or course for the same audience?</b>
      </div>
      <div className='answer-txt'>
        No, each session must be unique to be eligible for rewards. Repeating
        the same content for the same audience will not count toward task
        completion.
      </div>
      <div className='answer-txt'>
        For further assistance, please contact Marvin
      </div>
    </>
  ),
  4: (
    <>
      <div className='answer-txt'>
        b-Coin season 4 ends on <b>12.30.2025</b>.
      </div>
      <div className='answer-txt'>
        The participant who takes 1st place in the b-coin rating as of{' '}
        <b>12.30.2025</b>, will be able to choose any corporate merch from the
        store as an additional reward.
      </div>
      <div className='answer-txt'>
        Gifts worth as little as 150 b-coins can only be gained during{' '}
        <b>December 2025</b>.
      </div>
    </>
  ),
  5: (
    <div className='answer-txt'>
      No, the b-coin cannot be presented to other co-workers or combined to
      share the gift
    </div>
  ),
  6: (
    <>
      <div className='answer-txt'>
        You can leave a feedback about the company on <b>DOU</b>,{' '}
        <b>Glassdoor</b>, <b>Comparably</b> and <b>Google</b> <b>only once</b>.
      </div>
      <div className='answer-txt'>
        <i>
          We also ask you to leave your feedback after 48 hours after the
          previous one, which was posted in the profile.
        </i>
      </div>
    </>
  ),
  7: (
    <>
      {certifications.map((cert, index) => (
        <div className='answer-txt' key={index}>
          {cert.cost && <b>{cert.cost}</b>} {cert.description}
        </div>
      ))}
      <ul className='answer-txt-list'>
        {list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <div className='answer-txt'>
        <i>{note}</i>
      </div>
    </>
  ),
  8: (
    <>
      <div className='answer-txt'>
        You need to wait for about <b>2-10</b> business days from the date of
        request.
      </div>
      <div className='answer-txt'>
        The delivery time of the order depends on several factors, including{' '}
        <b>delivery and the availability of the goods</b> with us or the store.
      </div>
      <div className='answer-txt'>
        Branded goods, such as <b>T-shirts, cups, bags, and other merch</b>, can
        be produced in about <b>20 business days</b>, since this process takes
        longer and depends on design factors and the quantity of the product to
        be produced.
      </div>
    </>
  ),
};

export const selectAnswer = (index: number) => {
  return answerMap[index] || null;
};
